import React, { useContext, useState, useEffect, useRef } from "react"
import {
  Button,
  Form,
  FormGroup,
  Tabs,
  Tab,
  Row,
  Col,
  Popover,
  OverlayTrigger,
  ToggleButtonGroup,
  ToggleButton,
  Modal,
  Table,
  Toast,
  ToastContainer,
  Accordion,
  Alert,
} from "react-bootstrap"
import "./EditarCohorte.css"
import { UsuarioContext } from "../Context/Usuario"
import Loading from "../Utils/Loading"
import AtributoInput from "../Utils/AtributoInput"
import UAI from "../UAI"
import log from "loglevel"
import {
  MdError,
  MdHelpOutline,
  MdOutlineClose,
  MdOutlineList,
  MdOutlineNavigateNext,
  MdOutlineTab,
  MdSave,
} from "react-icons/md"
import ErrorMP from "../Utils/ErrorMP"
import NavegacionPasos from "../Utils/NavegacionPasos"
import PermisosAtributo from "../Utils/PermisosAtributo"
import { SiSalesforce } from "react-icons/si"

/**
 * Componente de edición de uno o más cohortes en simultáneo
 * @param {Object} props
 * @returns
 */
const EditarCohorte = (props) => {
  const { usuario, setUsuario } = useContext(UsuarioContext)

  const [cohortes, setCohortes] = useState(null)
  const [atributosPorCategoria, setAtributosPorCategoria] = useState(null)
  const [cambios, setCambios] = useState({})
  const [savingChanges, setSavingChanges] = useState(false)
  const [activeTab, setActiveTab] = useState(null)
  const [readonly, setReadonly] = useState(undefined)
  const [onlyRequired, setOnlyRequired] = useState(
    window.localStorage.getItem("onlyRequired") === "true"
  )
  const [seeAs, setSeeAs] = useState(null)
  const [tabsLayout, setTabsLayout] = useState(true)
  const [errorCohorte, setErrorCohorte] = useState(null)
  const [atributoDetalles, setAtributoDetalles] = useState(null)
  const [showDetallesAtributo, setShowDetallesAtributo] = useState(false)
  const [toasts, setToasts] = useState(null)
  const [errores, setErrores] = useState(null)
  const [reload, setReload] =useState(0)

  const agregarAtributoRequest = (atributo, element) => {
    let _atributo = usuario.atributos[atributo]
    if (
      _atributo.Tipo !== "SelectorMultiple" && (
      element === undefined ||
      element.target === undefined ||
      element.target.value === undefined)
    ) {
      log.debug(element)
      throw new Error("Valor inválido para poder actualizar")
    }
    if (
      _atributo.Tipo === "SelectorMultiple" && (
      element === undefined ||
      !Array.isArray(element))
    ) {
      log.debug(element)
      throw new Error("Valor inválido para poder actualizar en selector múltiple")
    }
    let _value = _atributo.Tipo === "SelectorMultiple" ? element : element.target.value
    let newCambios = JSON.parse(JSON.stringify(cambios))
    let singleCohorte = cohortes.length === 1 ? cohortes[0] : undefined
    if (
      (_value === "" &&
        singleCohorte &&
        singleCohorte[_atributo.key] === "" &&
        newCambios[atributo]) ||
      (!singleCohorte && newCambios[atributo])
    ) {
      delete newCambios[atributo]
    } else {
      if (_atributo.Tipo === "Json" || _atributo.Tipo === "SelectorMultiple") {
        if(_atributo.Tipo === "SelectorMultiple") {
          _value = _value.reduce((prev, current) => {
            prev.push({"id":current.value, "text":current.label})
            return prev
          }, [])
        }
        _value = JSON.stringify(_value)
      }
      if (!newCambios[atributo]) {
        newCambios[atributo] = {
          Codigo: atributo,
          Valor: _value,
          Categoria: _atributo.categoria,
        }
      } else {
        newCambios[atributo].Valor = _value
      }
    }
    setCambios(newCambios)
  }

  const resetState = () => {
    log.debug("Reset state!")
    setSavingChanges(true)
    setCambios({})
    setSavingChanges(false)
  }

  const cerrar = () => {
    log.debug("Cerrar!")
    resetState()
    if (props.cerrar) {
      props.cerrar()
    }
  }

  const avanzarPaso = () => {
    log.debug("Avanzando a paso siguiente")
    let singleBorrador =
      cohortes.length === 1 && cohortes[0].id < 0 ? cohortes[0] : undefined
    setSavingChanges(true)
    UAI.actualizarPasoBorrador(
      usuario.username,
      singleBorrador,
      (result) => {
        if (
          result.Estado &&
          result.Estado === "OK"
        ) {
          let errores = UAI.obtieneErroresActualizacionAtributosCohortes(result)
          if (errores) {
            log.debug(errores)
            guardarCambiosError(errores)
          } else {
            guardarCambiosSuccess(result)
          }
        } else {
          guardarCambiosError()
        }
      },
      (error) => {
        guardarCambiosError(error)
      }
    )
  }

  const guardarCambios = (avanzar) => {
    if (readonly) {
      log.warn("No se pueden guardar cambios cuando hay borradores")
      alert(
        "El cohorte que intenta modificar es un borrador. Por ahora no se puede realizar ese cambio"
      )
      return
    }
    log.debug("Guardando cambios!")
    log.debug(cambios)
    let singleBorrador =
      cohortes.length === 1 && cohortes[0].id < 0 ? cohortes[0] : undefined
    setSavingChanges(true)
    if (avanzar && singleBorrador) {
      UAI.actualizaAtributosCohortes(
        usuario.username,
        cohortes,
        Object.values(cambios),
        (result) => {
          log.debug(result)
          let errores = UAI.obtieneErroresActualizacionAtributosCohortes(result)
          if (errores) {
            log.debug(errores)
            guardarCambiosError(errores)
          } else {
            guardarCambiosSuccess(result)
          }
          UAI.actualizarPasoBorrador(
            usuario.username,
            singleBorrador,
            (result2) => {
              log.debug(result2)
              if (result2.Estado && result2.Estado === "OK") {
              } else {
                guardarCambiosError(result2)
              }
            },
            guardarCambiosError
          )
        },
        guardarCambiosError
      )
    } else {
      UAI.actualizaAtributosCohortes(
        usuario.username,
        cohortes,
        Object.values(cambios),
        (result) => {
          log.debug(result)
          let errores = UAI.obtieneErroresActualizacionAtributosCohortes(result)
          if (errores) {
            guardarCambiosError(errores)
            return
          } else {
            log.debug(errores)
            guardarCambiosSuccess(result)
          }
        },
        guardarCambiosError
      )
    }
  }

  const guardarCambiosSuccess = (result) => {
    log.debug("Success!")
    log.debug(result)
    setToasts([
      {
        type: "success",
        title: "Transacción exitosa",
        message: "Información de cohorte guardada exitosamente.",
      },
    ])
    setSavingChanges(false)
    setCambios({})
    setReload(reload+1)
    log.debug("Done!")
  }

  const guardarCambiosError = (error) => {
    log.debug("ERROR!")
    log.debug(error)
    let mensaje = (
      <div>
        Oops! Algunos problemas guardando cambios.
        <hr />
        {error && error.Estado && error.Estado === "NOK" && error.Mensaje}
      </div>
    )
    setToasts([{ type: "danger", title: "Error!", message: mensaje }])
    setSavingChanges(false)
    cerrar()
  }

  // TODO: Esto hay que hacerlo al leer los atributos al comienzo de la carga, en objeto Usuario
  const atributoDisponiblePaso = (atributo, pasoactualid, usuario) => {
    let permisosPaso = atributo.Permisos.find((p) => (p.PasoId = pasoactualid))
    if (!permisosPaso || permisosPaso.length === 0) {
      return false
    }
    let permiso = permisosPaso.reduce((prev, current) => {
      let currentPermiso =
        usuario.roles.indexOf(current.Perfil) >= 0 ? current.Permiso : null
      prev = prev || currentPermiso
      if (currentPermiso === "Editable") {
        prev = currentPermiso
      }
      return prev
    }, null)
  }

  useEffect(() => {
    log.debug("UseEffect editar cohorte!")

    if (savingChanges) {
      return
    }

    // TODO: Procesar IDs negativos para editar borradores
    let ids = props.cohortes.reduce((prev, current) => {
      let id = parseInt(current)
      prev.push(id)
      return prev
    }, [])

    UAI.obtieneDetallesCohortesPorId(
      ids,
      (r) => {
        if (
          !r ||
          !r[0] ||
          !r[0].Respuesta ||
          r[0].Respuesta === "No Encontrado/No Habilitado"
        ) {
          setErrorCohorte("Cohorte no encontrado o no habilitado")
          return
        }
        log.debug("Recalculando cohortes y atributos. " + r[0].nombre)
        // Variable para saber si testaremos en modo read only
        let readonly = false
        // Reduce de IDs de cohortes a los objetos
        r.forEach((c) => {
          UAI.agregaIdCohorte(c, null, "ProgramaId", "FacultadId")
        })
        let _cohortes = r
        log.debug(r)
        let singleBorrador = r.length === 1 && r[0].id < 0 ? r[0] : undefined
        // Si hay una vista definida, veremos solo esos atributos, de otra forma vemos todos los del usuario
        let _fields = props.view
          ? props.view.fields
          : Object.keys(usuario.atributos)
        let _atributos = {}
        _fields.forEach((field) => {
          let atributo = usuario.atributos[field]
          let visible = singleBorrador
            ? atributo.visiblePorPaso[singleBorrador.PasoActualId]
            : atributo.visible
          let editable = singleBorrador
            ? atributo.editablePorPaso[singleBorrador.PasoActualId]
            : atributo.editable
          if (
            seeAs !== null &&
            atributo.Permisos &&
            atributo.Permisos.length > 0
          ) {
            let permiso = atributo.Permisos.find(
              (p) =>
                (p.Perfil === seeAs && !singleBorrador) ||
                (singleBorrador &&
                  p.Perfil === seeAs &&
                  p.PasoId === singleBorrador.PasoActualId)
            )
            if (permiso) {
              visible = true
              if (permiso.Permiso === "Editable") {
                editable = true
              }
            }
          }
          // Si un atributo no es visible o no es editable al mismo tiempo que no nos exigen mostrar todo
          if (!visible) {
            return
          }
          // La categoría define la agrupación de atributos para tabs. Si por alguna razón no tiene atributos, lo dejamos en el tab "Otros"
          let _categoria = atributo.categoria || "Otros"
          // Si no debemos tener tabs, todos los atributos son de la categoría genérica "Atributos"
          if (props.notabs) {
            _categoria = "Atributos"
          }
          // Agregamos subcategorías para cada uno de los atributos
          let _subcategoria = atributo.Subcategoria || "-"
          // Inicializamos colección atributos
          _atributos[_categoria] = _atributos[_categoria] || {}
          _atributos[_categoria][_subcategoria] =
            _atributos[_categoria][_subcategoria] || []
          // Agregamos el atributo
          _atributos[_categoria][_subcategoria].push(atributo)
        })
        // Calcula el tab por defecto a abrir, dependiendo del paso en que está el borrador. Por defecto será la primera.
        let _defaultTab = Object.keys(_atributos).sort((a, b) => {
          return a.localeCompare(b)
        })[0]
        // Si tenemos un solo cohorte, entonces buscamos el tab para el paso actual.
        if (_cohortes.length === 1) {
          let c = _cohortes[0]
          let p = UAI.pasos.find((p) => p.id === c.PasoActualId)
          if (p) {
            let k = Object.keys(_atributos).find(
              (key) =>
                key.toLowerCase().includes(p.title.toLowerCase()) &&
                key.startsWith(p.id.toString())
            )
            if (k && k.length > 0) {
              _defaultTab = k
            }
          }
        }
        log.debug(_defaultTab)
        setCohortes(_cohortes)
        setAtributosPorCategoria(_atributos)
        setActiveTab(_defaultTab)
        setReadonly(readonly)
        setCambios({})
      },
      (e) => {
        log.debug("ERROR!")
        log.debug(e)
      },
      Object.keys(usuario.atributos).concat([
        "FacultadId",
        "MaestroId",
        "PasoActualId",
        "GradoId",
      ])
    )
  }, [
    props.cohortes,
    props.notabs,
    props.showall,
    props.view,
    usuario,
    seeAs,
    props.reload,
    reload
  ])

  const nombreAtributo = (atributo) => {
    return atributo.Nombre
  }

  if (errorCohorte) {
    return <ErrorMP>{errorCohorte}</ErrorMP>
  }

  if (savingChanges) {
    return (
      <Loading message="Guardando cambios en Maestro de Productos, por favor espere" />
    )
  }

  if (
    !cohortes ||
    cohortes.length === 0 ||
    !atributosPorCategoria ||
    !activeTab ||
    readonly === undefined
  ) {
    return (
      <Loading
        message={"Cargando datos de cohortes: " + props.cohortes.join(",")}
      />
    )
  }

  log.debug("Dibujando editar cohorte " + activeTab)

  let singleCohorte = cohortes.length === 1 ? cohortes[0] : undefined
  let [pasoActual, pasoSiguiente] = UAI.obtienePasoActualSiguiente(
    singleCohorte
  )

  let perfiles = {}
  Object.values(atributosPorCategoria).forEach((c) => {
    Object.values(c).forEach((k) => {
      k.forEach((atributo) => {
        atributo.Permisos.forEach((permiso) => {
          if (permiso.Perfil) perfiles[permiso.Perfil] = 1
        })
      })
    })
  })

  let fullContent = Object.keys(atributosPorCategoria)
    .sort((a, b) => {
      return a.localeCompare(b)
    })
    .filter((cat) => {
      let _totalRequeridos = Object.values(atributosPorCategoria[cat]).reduce(
        (prev, current) => {
          return prev + current.reduce((p, c) => (c.Obligatorio ? p + 1 : p), 0)
        },
        0
      )
      return _totalRequeridos > 0 || !onlyRequired
    })
    .map((categoria, idx) => {
      let _totalCambios = Object.values(cambios).reduce(
        (prev, current) => (current.Categoria === categoria ? prev + 1 : prev),
        0
      )
      let _totalRequeridosPendientes = Object.values(
        atributosPorCategoria[categoria]
      ).reduce((prev, current) => {
        return (
          prev +
          current.reduce(
            (p, c) =>
              singleCohorte &&
              c.Obligatorio &&
              c.validar &&
              !c.validar(singleCohorte)
                ? p + 1
                : p,
            0
          )
        )
      }, 0)
      let title = (
        <div>
          {categoria}
          {_totalCambios > 0 && (
            <div className="cambios-categoria">{_totalCambios}</div>
          )}
          {_totalRequeridosPendientes > 0 && (
            <div className="requeridos text-danger">
              <MdError />
            </div>
          )}
        </div>
      )
      let activekeys = Object.keys(atributosPorCategoria[categoria]).reduce((prev, current) => { 
        prev.push(categoria + "-" + prev.length)
        return prev
      }, [])
      let content = (
        <Row>
          <Accordion defaultActiveKey={activekeys} alwaysOpen>
            {Object.keys(atributosPorCategoria[categoria])
              .sort((a, b) => a.localeCompare(b))
              .map((subcategoria, idxsub) => {
                return (
                  <Accordion.Item eventKey={categoria+"-"+idxsub}  key={categoria+"-"+idxsub}>
                    <Accordion.Header>{subcategoria}</Accordion.Header>
                    <Accordion.Body>
                      <Row>
                        {atributosPorCategoria[categoria][subcategoria]
                          .sort(function (a, b) {
                            let sa =
                              a.Orden && a.Tipo !== "Json" && a.Tipo !== "Link"
                                ? a.Orden
                                : 1000
                            let sb =
                              b.Orden && b.Tipo !== "Json" && b.Tipo !== "Link"
                                ? b.Orden
                                : 1000
                            return sa - sb
                          })
                          .filter((a) => {
                            return (
                              (props.view && a.visible) ||
                              (singleCohorte &&
                                singleCohorte.id > 0 &&
                                a.visible) ||
                              (singleCohorte &&
                                singleCohorte.id < 0 &&
                                a.visiblePorPaso[singleCohorte.PasoActualId])
                            )
                          })
                          .map((atributo, idx2) => {
                            let colClasses = []
                            if (cambios[atributo.key] !== undefined) {
                              colClasses.push("cambios")
                            }
                            if (atributo.editable) {
                              colClasses.push("editable")
                            }
                            if (!atributo.Obligatorio && onlyRequired) {
                              colClasses.push("atributoNoRequeridoOculto")
                            }
                            return (
                              <Col
                                xs={Math.max(
                                  6,
                                  atributo.Tipo === "Json" ||
                                    atributo.Tipo === "Link"
                                    ? 12
                                    : parseInt(atributo.DespliegueAncho) * 3
                                )}
                                md={Math.max(
                                  4,
                                  atributo.Tipo === "Json" ||
                                    atributo.Tipo === "Link"
                                    ? 12
                                    : parseInt(atributo.DespliegueAncho) * 3
                                )}
                                lg={Math.max(
                                  3,
                                  atributo.Tipo === "Json" ||
                                    atributo.Tipo === "Link"
                                    ? 12
                                    : parseInt(atributo.DespliegueAncho) * 3
                                )}
                                key={"col-" + idx2}
                                className={
                                  "atributo-container " + colClasses.join(" ")
                                }
                              >
                                <FormGroup>
                                  <Form.Label title={atributo.Codigo}>
                                    {atributo.Obligatorio && (
                                      <span
                                        className="requeridos text-danger"
                                        title="Obligatorio"
                                      >
                                        *
                                      </span>
                                    )}
                                    <span
                                      title={
                                        "Clic para detalles de " +
                                        atributo.Nombre
                                      }
                                      onClick={() => {
                                        setAtributoDetalles(atributo)
                                        setShowDetallesAtributo(true)
                                      }}
                                      style={{
                                        cursor: "help",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {" " + nombreAtributo(atributo) + " "}
                                    </span>
                                    {atributo.Descripcion &&
                                      atributo.Descripcion.length > 0 && (
                                        <OverlayTrigger
                                          trigger="click"
                                          key={"help-" + idx2}
                                          placement="top"
                                          overlay={
                                            <Popover
                                              className="popover-atributo"
                                              id={"popover-" + atributo.Codigo}
                                            >
                                              <Popover.Header>
                                                {atributo.Nombre}
                                              </Popover.Header>
                                              <Popover.Body>
                                                {atributo.Descripcion}
                                              </Popover.Body>
                                            </Popover>
                                          }
                                        >
                                          <span>
                                            <MdHelpOutline
                                              title={
                                                "Ayuda para " + atributo.Nombre
                                              }
                                            />
                                          </span>
                                        </OverlayTrigger>
                                      )}
                                    {atributo.Obligatorio &&
                                      singleCohorte &&
                                      atributo.validar &&
                                      !atributo.validar(singleCohorte) && (
                                        <span
                                          className="text-danger"
                                          title="Obligatorio"
                                        >
                                          <MdError />
                                        </span>
                                      )}
                                    {atributo.EsActualizableSalesforce && (
                                      <SiSalesforce
                                        title={
                                          "Se sincroniza a Salesforce en atributo: " +
                                          atributo.NombreCampoSalesforce
                                        }
                                        style={{ color: "#00a1e0" }}
                                      ></SiSalesforce>
                                    )}
                                  </Form.Label>
                                  <AtributoInput
                                    atributo={atributo}
                                    cohorte={
                                      cohortes.length === 1
                                        ? cohortes[0]
                                        : undefined
                                    }
                                    inline={true}
                                    disabled={readonly}
                                    onChange={(element) => {
                                      if (readonly) {
                                        alert(
                                          "No se debe cambiar el atributo en modo read only"
                                        )
                                        return
                                      }
                                      if (!element) {
                                        log.debug(
                                          "Cambio enviado por " +
                                            atributo.key +
                                            " pero sin datos"
                                        )
                                        return
                                      }
                                      if (atributo.editable) {
                                        log.debug(
                                          "Atributo " +
                                            atributo.key +
                                            " cambiado!"
                                        )
                                        agregarAtributoRequest(
                                          atributo.key,
                                          element
                                        )
                                      } else {
                                        log.debug(
                                          "Atributo " +
                                            atributo.key +
                                            " no es editable"
                                        )
                                      }
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            )
                          })}
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                )
              })}
          </Accordion>
        </Row>
      )

      if (tabsLayout)
        return (
          <Tab key={idx} eventKey={categoria} title={title}>
            {content}
          </Tab>
        )
      else
        return (
          <div key={idx} className="fullLayoutCategoria">
            <div className="h4">
              <div className="tituloCategoria">{title}</div>
            </div>
            {content}
          </div>
        )
    })

  let _toasts = <></>
  if (toasts && toasts.length > 0) {
    return (
      <ToastContainer
        position="top-center"
        className="p-3"
        style={{ marginTop: "6rem" }}
      >
        {toasts.map((t, idx3) => {
          return (
            <Toast
              key={"toast-" + idx3}
              show={toasts && toasts.length > 0}
              onClose={() => {
                setToasts(null)
              }}
            >
              <Toast.Header>
                <strong className="me-auto">{t.title}</strong>
                <small>&nbsp;</small>
              </Toast.Header>
              <Toast.Body><Alert variant={t.type}>{t.message}</Alert></Toast.Body>
            </Toast>
          )
        })}
      </ToastContainer>
    )
  }

  let pasos = <></>
  if (singleCohorte) {
    if (singleCohorte.id < 0) {
      pasos = (
        <NavegacionPasos
          pasos={UAI.pasos}
          pasoactualid={singleCohorte.PasoActualId}
        />
      )
    } else {
      let _pasos = []
      let _pasoActual = null
      Object.values(UAI.EtapasCicloVidaCohortes).forEach((paso) => {
        _pasos.push({ id: paso.key, title: paso.nombre })
        if (paso.filtro(singleCohorte, usuario.periodo)) {
          _pasoActual = paso.key
        }
      })
      pasos = <NavegacionPasos pasos={_pasos} pasoactualid={_pasoActual} />
    }
  }

  return (
    <>
      <div className="EditarCohorte">
        {_toasts}
        <Row className="editarcohorte-tools">
          <Col>
            {usuario.esadministrador && (
              <Form.Select
                className="verComo"
                defaultValue={seeAs}
                onChange={(e) => {
                  setCohortes(null)
                  setSeeAs(e.target.value)
                }}
              >
                <option value="">Ver como</option>
                {Object.keys(perfiles).map((p, idx) => (
                  <option key={"p-" + idx} value={p}>
                    {p}
                  </option>
                ))}
              </Form.Select>
            )}
            {!usuario.esadministrador && <>&nbsp;</>}
          </Col>
          <Col>
            <ToggleButtonGroup
              type="radio"
              name="options"
              defaultValue={tabsLayout ? 1 : 2}
              onChange={(e) => {
                setTabsLayout(e === 1)
              }}
            >
              <ToggleButton
                id="tbg-radio-1"
                value={1}
                title="Mostrar en pestañas"
                variant="outline-primary"
                className="botonLayout"
              >
                <MdOutlineTab />
              </ToggleButton>
              <ToggleButton
                id="tbg-radio-2"
                value={2}
                title="Mostrar como lista"
                variant="outline-primary"
                className="botonLayout"
              >
                <MdOutlineList />
              </ToggleButton>
            </ToggleButtonGroup>
          </Col>
          <Col>
            <Form.Check
              type="checkbox"
              label="&nbsp;Ver solo obligatorios"
              className="verSoloRequeridos"
              onChange={() => {
                log.debug("Cambiando a " + !onlyRequired)
                let storage = window.localStorage
                storage.setItem("onlyRequired", !onlyRequired)
                setOnlyRequired(!onlyRequired)
              }}
              defaultChecked={onlyRequired}
            ></Form.Check>
          </Col>
        </Row>
        {pasos}
        <Form>
          {tabsLayout && (
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => {
                setActiveTab(k)
              }}
              className="with-arrow lined nav-pills sticky-top"
            >
              {fullContent}
            </Tabs>
          )}
          {!tabsLayout && <div className="fullLayout">{fullContent}</div>}
          <Row className="editarcohorte-tools">
            <Col className="text-center">
              <Button
                variant={
                  Object.values(cambios).length > 0
                    ? "primary"
                    : "outline-primary"
                }
                className={""}
                onClick={() => {
                  guardarCambios()
                }}
                disabled={Object.values(cambios).length === 0}
                title={
                  Object.values(cambios).length === 0
                    ? "No hay cambios"
                    : "Guardar cambios"
                }
              >
                <MdSave />
                Guardar cambios
              </Button>
              {singleCohorte &&
                singleCohorte.id < 0 &&
                pasoSiguiente &&
                Object.values(cambios).length > 0 && (
                  <Button
                    variant={"primary"}
                    onClick={() => {
                      guardarCambios(true)
                    }}
                    title={"Guardar cambios y avanzar"}
                  >
                    <MdOutlineNavigateNext />
                    Guardar y avanzar a {pasoSiguiente.title}
                  </Button>
                )}
              {singleCohorte &&
                singleCohorte.id < 0 &&
                pasoSiguiente &&
                Object.values(cambios).length === 0 && (
                  <Button
                    variant={"primary"}
                    onClick={() => {
                      avanzarPaso()
                    }}
                    title={"Avanzar a siguiente paso"}
                  >
                    <MdOutlineNavigateNext />
                    Avanzar a {pasoSiguiente.title}
                  </Button>
                )}
              {props.cerrar && (
                <Button
                  variant="secondary"
                  onClick={() => {
                    cerrar()
                  }}
                >
                  <MdOutlineClose />
                  Cerrar
                </Button>
              )}
              {!props.cerrar && Object.values(cambios).length > 0 && (
                <Button
                  variant="secondary"
                  onClick={() => {
                    cerrar()
                  }}
                >
                  <MdOutlineClose />
                  Descartar cambios
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>&nbsp;</Col>
          </Row>
        </Form>
      </div>
      <Modal
        show={showDetallesAtributo}
        onHide={() => {
          setAtributoDetalles(null)

          setShowDetallesAtributo(false)
        }}
      >
        <Modal.Header className="h4" closeButton>
          Atributo {atributoDetalles ? atributoDetalles.Nombre : ""}
        </Modal.Header>
        <Modal.Body>
          {atributoDetalles && (
            <Table>
              <tbody>
                <tr>
                  <td>Categoría</td>
                  <td>{atributoDetalles.Categoria}</td>
                </tr>
                <tr>
                  <td>Código</td>
                  <td>{atributoDetalles.Codigo}</td>
                </tr>
                <tr>
                  <td>Nombre</td>
                  <td>{atributoDetalles.Nombre}</td>
                </tr>
                <tr>
                  <td>Tipo</td>
                  <td>{atributoDetalles.Tipo}</td>
                </tr>
                <tr>
                  <td>Descripción</td>
                  <td>{atributoDetalles.Descripción}</td>
                </tr>
                <tr>
                  <td>Orden</td>
                  <td>{atributoDetalles.Orden}</td>
                </tr>
                <tr>
                  <td>Permisos</td>
                  <td>
                    <PermisosAtributo permisos={atributoDetalles.Permisos} />
                  </td>
                </tr>
              </tbody>
            </Table>
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EditarCohorte
